import React from "react";
import { createRoot, Root } from "react-dom/client";
import { CRMDatePicker } from "./CRMDatePicker";

type DotNetRef = {
  invokeMethodAsync: (method: string, ...args: any[]) => Promise<any>;
};

type PickerState = {
  root: Root;
  dotNetRef: DotNetRef;
  date: Date | string | null;
  showTime: boolean;
};

const states = new Map<string, PickerState>();

export function mount(
  hostId: string,
  date: Date | string | null,
  showTime: boolean,
  dotNetRef: DotNetRef
): void {
  const el: HTMLElement | null = document.getElementById(hostId);
  if (!el) return;

  // Safety: don’t double-mount
  if (states.has(hostId)) return;

  const root: Root = createRoot(el);

  states.set(hostId, {
    root,
    dotNetRef,
    date,
    showTime
  });

  render(hostId);
}

export function set(
  hostId: string,
  date: Date | string | null,
  showTime: boolean
): void {
  const st: PickerState | undefined = states.get(hostId);
  if (!st) return;

  st.date = date;
  st.showTime = showTime;

  render(hostId);
}

export function unmount(hostId: string): void {
  const st: PickerState | undefined = states.get(hostId);
  if (!st) return;

  st.root.unmount();
  states.delete(hostId);
}

function render(hostId: string): void {
  const st: PickerState | undefined = states.get(hostId);
  if (!st) return;

  st.root.render(
    <CRMDatePicker
      defaultDate={st.date ?? new Date()}
      showTime={st.showTime}
      onChange={(d: Date): Promise<any> =>
        st.dotNetRef.invokeMethodAsync(
          "OnDateChanged",
          d.toISOString()
        )
      }
      onShowTimeChange={(v: boolean): Promise<any> =>
        st.dotNetRef.invokeMethodAsync(
          "OnShowTimeChanged",
          v
        )
      }
    />
  );
}